import { useContext, useSyncExternalStore } from 'react'
import { CustomizationContext } from '../context/CustomizationContextProvider'

/**
 * Temporary prod testing: append `?shop_pay_preview=1` (or `true`) to show Shop Pay
 * even when the client setting is off. Remove when no longer needed.
 */
export const SHOP_PAY_PREVIEW_QUERY_PARAM = 'shop_pay_preview'

export function shopPayPreviewEnabledFromSearch(search: string): boolean {
    const q = search.startsWith('?') ? search.slice(1) : search
    const params = new URLSearchParams(q)
    if (!params.has(SHOP_PAY_PREVIEW_QUERY_PARAM)) return false
    const v = params.get(SHOP_PAY_PREVIEW_QUERY_PARAM)
    return v === null || v === '' || v === '1' || v === 'true'
}

function readPreviewFromWindow(): boolean {
    if (typeof window === 'undefined') return false
    return shopPayPreviewEnabledFromSearch(window.location.search)
}

/** No-op subscribe: query string is fixed for the loaded document; no client store updates needed. */
function subscribeToNothing(_onStoreChange: () => void): () => void {
    return () => {}
}

/**
 * `true` when client settings enable Shop Pay, or when `?shop_pay_preview=1` is present (testing).
 * Uses `useSyncExternalStore` so we can read `window` on the client without SSR/hydration mismatch
 * (server snapshot is always `false` for the preview flag).
 */
export function useShopPayButtons(): boolean {
    const { displayShopPayButtons } = useContext(CustomizationContext)
    const preview = useSyncExternalStore(
        subscribeToNothing,
        readPreviewFromWindow,
        () => false,
    )
    return displayShopPayButtons || preview
}
